import { render, staticRenderFns } from "./PostsCalendar.vue?vue&type=template&id=76d122e2&"
import script from "./PostsCalendar.vue?vue&type=script&lang=js&"
export * from "./PostsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports